export default {"src":"/_next/static/media/arrowDown.7e4d76bb.svg","height":7,"width":14,"blurWidth":0,"blurHeight":0};